/*
 * video-format-registry.js — the JS face of config/video-formats.php.
 *
 * WHY IT EXISTS. Video tools used to know three things by hand: which
 * containers to offer, what extension/MIME each one produces, and which codec
 * to encode with. The first two were copy-pasted into 17 blades (MOV survived
 * in two of them, AVI in none); the third is genuine engine knowledge that
 * already belongs to codec-mux-rules.js / video-exporter.js. This module owns
 * ONLY the catalogue half, reading it from the server-rendered snapshot so the
 * config file stays the single source of truth.
 *
 *   window.__VIDEO_FORMATS = { mp4: {label, ext, mime, video_codec, ...}, ... }
 *
 * The snapshot is emitted by the <x-video-format-select> / <x-video-exporter>
 * components, i.e. only on pages that actually export video — a page with no
 * video export ships none of this.
 *
 * API (all fail SOFT: an unknown format returns null / a sane default, never
 * throws, because a tool mid-export must not die over a label lookup):
 *
 *   VideoFormats.all()                → the catalogue object
 *   VideoFormats.get('mov')           → entry | null
 *   VideoFormats.ext('mov')           → 'mov'
 *   VideoFormats.mime('mov')          → 'video/quicktime'
 *   VideoFormats.label('mov')         → 'MOV'
 *   VideoFormats.videoCodec('webm')   → 'libvpx'      (⛔ never libvpx-vp9)
 *   VideoFormats.audioCodec('webm')   → 'libopus'
 *   VideoFormats.isLegacy('avi')      → true
 *   VideoFormats.usable()             → keys minus anything marked broken
 *   VideoFormats.resolve(sel, srcExt) → 'same' → the source container
 *
 * ⚠️ NOT here, on purpose: "can this stream be copied", "what -pix_fmt", "what
 * CRF". Ask window.CodecMuxRules / VideoExporter. Two modules answering the
 * same question is how the tools drifted apart in the first place.
 */
(function () {
    'use strict';

    function catalogue() {
        var c = window.__VIDEO_FORMATS;
        return (c && typeof c === 'object') ? c : {};
    }

    function get(fmt) {
        if (!fmt) return null;
        var e = catalogue()[String(fmt).toLowerCase()];
        return e || null;
    }

    /* 'same' means "keep the input container" — the one selection value that is
       NOT a registry key. Resolving it needs the source extension, which only
       the tool knows, so it is a parameter and not a guess. */
    function resolve(selected, sourceExt) {
        var s = String(selected || '').toLowerCase();
        if (s && s !== 'same') return s;
        var src = String(sourceExt || '').toLowerCase().replace(/^\./, '');
        return get(src) ? src : 'mp4';
    }

    window.VideoFormats = {
        all: catalogue,
        get: get,
        ext:   function (f) { var e = get(f); return e ? e.ext : String(f || '').toLowerCase(); },
        mime:  function (f) { var e = get(f); return e ? e.mime : 'video/mp4'; },
        label: function (f) { var e = get(f); return e ? e.label : String(f || '').toUpperCase(); },
        videoCodec: function (f) { var e = get(f); return e ? e.video_codec : 'libx264'; },
        audioCodec: function (f) { var e = get(f); return e ? e.audio_codec : 'aac'; },
        alphaOk:    function (f) { var e = get(f); return !!(e && e.alpha); },
        isLegacy:   function (f) { var e = get(f); return !!(e && e.status === 'legacy'); },
        noPreview:  function (f) { var e = get(f); return !!(e && e.no_preview); },
        usable: function () {
            var c = catalogue(), out = [];
            for (var k in c) if (Object.prototype.hasOwnProperty.call(c, k) && c[k].status !== 'broken') out.push(k);
            return out;
        },
        resolve: resolve
    };
})();
